// import React from 'react'

function badgeClass (statusCode) {
  const s = String(statusCode)
  if (s.startsWith('2')) return 'bg-success'
  if (s.startsWith('4') || s.startsWith('5')) return 'bg-danger'
  return 'bg-warning text-dark'
}

export function GlobalCallbackStatusBadge ({ statusCode }) {
  return <span className={`status-${badgeClass(statusCode)}`}>{statusCode}</span>
}

export default GlobalCallbackStatusBadge
